<ng-container *ngIf="tipoPratica == null">
  <app-tipo-pratica-widget
    [tipoPratica]="tipoPratica"
    [tipoPraticaSugg]="getMatter()"
    (tipoPraticaChange)="setTipoPratica($event)"
  >
  </app-tipo-pratica-widget>
</ng-container>
<ng-container *ngIf="tipoPratica != null">
  <app-dati-gen-pratica-form
    [pratica]="pratica"
    [tipoPratica]="tipoPratica"
    (datiGeneraliChange)="updateDatiGenerali($event)"
    [resetForm]="resetForm"
    (valid)="changeValidity($event)"
  ></app-dati-gen-pratica-form>
  <app-classificazioni [classificazioni]="classificazioni"
  [hasPrincipale]="hasPrincipale"
  (classificazioneEmitter)="addClassificazione($event)"
  (classificazioneRemover)="removeClassificazione($event)"></app-classificazioni>

  <div class="row wizard-buttons">
    <p class="col-sm-3 col-xs-6">
      <button type="button" class="btn btn-outline-secondary btn-block" (click)="reset()">Reset</button>
    </p>
    <p
      class="col-sm-3 col-xs-6 col-sm-offset-6">
      <button type='button' class='btn btn-primary btn-block' [disabled]="checkDisabledBtn()" (click)="salva()">
        Prosegui
      </button>
    </p>

  </div>
</ng-container>

